// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3fRhO","log":"ModalInventoryLogs_log__2u07L","date":"ModalInventoryLogs_date__3jby2","userName":"ModalInventoryLogs_userName__2OwnJ"};